import classNames from 'classnames';

import ScreenReaderOnly from '../../../ScreenReaderOnly';

import styles from './_index.module.scss';

export interface StepProps {
  activeIndex: number;
  index: number;
  isComplete?: boolean;
  isDisabled?: boolean;
  label: string;
  onClick: (index: number) => void;
}

const Step = ({ activeIndex, index, isComplete, isDisabled, label, onClick }: StepProps) => {
  const isActive = activeIndex === index;
  const isPast = activeIndex > index;
  return (
    <div
      className={classNames(styles['step'], {
        [styles['is-active']]: isActive,
        [styles['is-complete']]: isComplete,
        [styles['is-disabled']]: isDisabled,
        [styles['is-past']]: isPast,
      })}
      onClick={() => onClick(index)}
      tabIndex={isDisabled ? -1 : 0}
    >
      <span aria-hidden="true" className={styles['step-icon']}>
        <span>{index + 1}</span>
      </span>
      {isActive && <ScreenReaderOnly>Current:</ScreenReaderOnly>}
      {isPast && isComplete && <ScreenReaderOnly>Completed:</ScreenReaderOnly>}
      <span className={styles['step-label']}>{label}</span>
    </div>
  );
};

export default Step;
